import React from 'react';
import { connect } from "react-redux";
import createClient from '../../../API/Admin/AddClient'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import { withRouter } from 'react-router-dom';
import Loader from './../../../Global/loader'

class CreateClient extends React.Component {
  
    state={
        domainName: '',
        naziv: '',
        oib: '',
        adresa: '',
        email: '',
        telefon: '',
        pdv: true,
        countryUuid: "0e774223-8db4-442e-949d-55dbd1c90d48",
        clientTypeUuid: "cd76c124-4788-4a60-a6c9-c9bda24c2816",
        loading: true
    }

    componentDidMount(){
        document.title = "Kreiranje Klijenta"

        this.setState({
            loading: false
        })
    }

    handleChange(e){      
        this.setState({
            [e.target.id]: e.target.value
        })        
    }

    addNewClient = async (e) => {
        e.preventDefault()
        this.setState({ loading: true })
        
        let createdUser = await createClient(this.state) 
        if(createdUser.data.status !== 201){
            store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom kreiranja klijenta, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        else{           
            store.addNotification({
                title: "Uspjeh!",
                message: "Klijent " + this.state.naziv + " je uspješno kreirana.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({
                domainName: '',
                naziv: '',
                oib: '',
                adresa: '',
                email: '',
                telefon: '',
                pdv: true,
                countryUuid: "0e774223-8db4-442e-949d-55dbd1c90d48",
                clientTypeUuid: "cd76c124-4788-4a60-a6c9-c9bda24c2816"
            })  

            this.props.history.push("/Admin/client")
        }
        
        
    }

    handlePdv = async () => {
        this.setState({
            pdv: !this.state.pdv
        })
    } 

    render(){  

        return (

            <main style={{}}>                
                <header>
                    <h1>
                        Kreiranje Klijenta
                    </h1>      
                </header>    

                {this.state.loading ?
                    <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                        <Loader />
                    </div>
                :
                <>
                <form style={{padding: "0px 40px 40px 40px"}}>
                    <div className="form-group row">
                        <label htmlFor="naziv" className="col-sm-2 col-form-label">Naziv</label>
                        <div className="col-sm-4">
                            <input        
                                id="naziv"                    
                                type="text"
                                
                                onChange={e => this.handleChange(e)}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="domainName" className="col-sm-2 col-form-label">Naziv domene</label>
                        <div className="col-sm-4">
                            <input   
                                id="domainName"                       
                                type="text"
                                value={this.state.domainName}
                                onChange={e => this.handleChange(e)}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="oib" className="col-sm-2 col-form-label">OIB</label>
                        <div className="col-sm-4">
                            <input    
                                minLength="11"
                                maxLength="11"
                                id="oib"                                             
                                type="text"
                                value={this.state.oib}
                                onChange={e => this.handleChange(e)}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="adresa" className="col-sm-2 col-form-label">Adresa</label>
                        <div className="col-sm-4">
                            <input    
                                id="adresa"                                           
                                type="text"
                                value={this.state.adresa}
                                onChange={e => this.handleChange(e)}
                            />
                        </div>
                    </div>            
                    <div className="form-group row">
                        <label htmlFor="email" className="col-sm-2 col-form-label">Email</label>
                        <div className="col-sm-4">
                            <input   
                                id="email"                  
                                type="text"
                                value={this.state.email}
                                onChange={e => this.handleChange(e)}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="telefon" className="col-sm-2 col-form-label">Telefon</label>
                        <div className="col-sm-4">
                            <input      
                                id="telefon"                                           
                                type="text"
                                value={this.state.telefon}
                                onChange={e => this.handleChange(e)}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label htmlFor="pdv" className="col-sm-2 col-form-label">PDV</label>
                        <div className="col-sm-10">
                        <label className="form-check-label" htmlFor="gridCheck2">
                            <input      
                                id="pdv"                                          
                                type="checkbox"
                                checked={this.state.pdv}
                                onChange={e => this.handlePdv(e)}
                            />
                            
                            &nbsp;&nbsp; u sustavu pdv-a
                            </label>
                        
                        </div>
                    </div>

                    <div className="form-group row">
                        <label htmlFor="PosBr" className="col-sm-2 col-form-label"></label>
                        <div className="col-sm-2">
                            <button                                 
                                className="btn btn-info" 
                                style={{padding:"10px"}} 
                                onClick={(e)=> this.addNewClient(e)}
                            >
                                Spremi
                            </button>
                        </div>
                    </div>            
                </form>
                
                    <div className="form-group" style={{marginTop: "30px"}}>
                        <a 
                            href="#/Admin/client"
                            className="btn btn-default" 
                            style={{marginBottom: "10px"}}                        
                        > 
                            <BsBackspaceFill size={30} />  
                            <strong> Nazad </strong>
                        </a> 
                    </div>
                </>
                }
            </main>
        )
    }
}
const mapStateToProps = state => {
    return {
        credentials: state.user.credentials
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateClient));


